
(function () {
    // console.log('[Zendesk] Initializing consent integration');

    // Function to check consent status and show/hide Zendesk widget
    function checkConsentAndToggleWidget() {
        // Wait for Shopify customer privacy API
        if (typeof Shopify === 'undefined' || !Shopify.customerPrivacy) {
            // console.log('[Zendesk] Shopify customer privacy API not available yet');
            return;
        }

        // Wait for Zendesk widget
        if (typeof window.zE === 'undefined') {
            console.log('[Zendesk] Widget not loaded yet');
            return;
        }

        // IMMEDIATELY set cookies to "none" to prevent any cookies from being saved
        // before we check consent status
        try {
            window.zE('messenger:set', 'cookies', 'none');
            // console.log('[Zendesk] Pre-emptively set cookies to "none"');
        } catch (preError) {
            // console.error('[Zendesk] Error setting pre-emptive cookies:', preError);
        }

        try {
            // Get consent status from Shopify
            const consent = Shopify.customerPrivacy.getTrackingConsent();

            // console.log('[Zendesk] Consent status:', consent);

            // Check if consent is granted (returns "yes" string or object with properties)
            const hasConsent = consent === 'yes' ||
                (consent && typeof consent === 'object' &&
                    (consent.marketingAllowed || consent.analyticsAllowed));

            // console.log('[Zendesk] Has consent:', hasConsent, 'Type:', typeof consent);

            if (hasConsent) {
                // Consent granted - show widget
                // console.log('[Zendesk] ✅ Consent granted - showing widget');

                // Remove the CSS that hides the widget
                const hideStyle = document.getElementById('zendesk-consent-hide');
                if (hideStyle) {
                    hideStyle.remove();
                    // console.log('[Zendesk] Removed hide CSS');
                }

                // Show the widget and set cookies
                try {
                    window.zE('messenger', 'show');
                    window.zE('messenger:set', 'cookies', 'all');
                    // console.log('[Zendesk] Widget shown and cookies set to "all"');
                } catch (error) {
                    console.error('[Zendesk] Error showing widget:', error);
                }
            } else {
                // No consent - hide widget and prevent cookies
                // console.log('[Zendesk] ❌ No consent - hiding widget and preventing cookies');
                try {
                    // Set cookies to "none" FIRST to prevent any cookies from being saved
                    window.zE('messenger:set', 'cookies', 'none');

                    // Then hide the widget
                    window.zE('messenger', 'hide');

                    // console.log('[Zendesk] Widget hidden and cookies set to "none"');

                    // Clear any existing Zendesk localStorage data
                    try {
                        const localStorageKeys = Object.keys(localStorage);
                        localStorageKeys.forEach(key => {
                            if (key.includes('ZD') || key.includes('zendesk') || key.includes('zE') ||
                                key.endsWith('.appUserId') || key.endsWith('.sessionToken') ||
                                key.endsWith('.conversationStartedAt')) {
                                localStorage.removeItem(key);
                                // console.log('[Zendesk] Removed localStorage key:', key);
                            }
                        });
                    } catch (storageError) {
                        console.error('[Zendesk] Error clearing localStorage:', storageError);
                    }
                } catch (error) {
                    console.error('[Zendesk] Error hiding widget:', error);
                }
            }
        } catch (error) {
            console.error('[Zendesk] Error checking consent:', error);
        }
    }

    // Listen for consent changes
    function setupConsentListener() {
        // Listen for the visitorConsentCollected DOM event
        document.addEventListener('visitorConsentCollected', function (event) {
            //  console.log('[Zendesk] Consent updated:', event.detail);
            checkConsentAndToggleWidget();
        });
    }

    // Initialize when page loads
    function init() {
        // Set up consent listener immediately
        setupConsentListener();

        // Check immediately and then periodically until both APIs are ready
        checkConsentAndToggleWidget();

        const interval = setInterval(function () {
            if (typeof Shopify !== 'undefined' && Shopify.customerPrivacy && typeof window.zE !== 'undefined') {
                // console.log('[Zendesk] APIs ready');
                clearInterval(interval);
                checkConsentAndToggleWidget();
            }
        }, 100);

        // Stop checking after 10 seconds
        setTimeout(function () {
            clearInterval(interval);
        }, 10000);
    }

    // Start on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
